import * as React from 'react'
import { styled } from 'next-yak'

import * as styles from '../styles'

export type GlyphPastilleProps = {
  className?: string
  status: 'failed' | 'pending' | 'succeeded' | 'waiting'
  withBackground?: boolean
} 

export function GlyphPastilleComponent({
  className,
  status,
  withBackground = true,
}: GlyphPastilleProps): React.ReactElement<any> {
  const Glyph = styles.glyphPastille.statusGlyph[status]

  return (
    <styles.glyphPastille.IconPastille className={className} $status={status} $withBackground={withBackground}>
      <Glyph size={18} />
    </styles.glyphPastille.IconPastille>
  )
}

export const GlyphPastille = styled(GlyphPastilleComponent)``
